import { Typography } from "@mui/material";
import type { FC } from "react";
import { useTranslation } from "react-i18next";
import { useHospitalData } from "../../contexts/HospitalDataProvider";
import { FONT_SIZE } from "../../theme/tokens";
import { OTHER_DEPARTMENT_MARKER } from "./consts";
import { hasOtherDepartmentRule, type WageComposition } from "./wageComposition";

type Props = { composition: WageComposition };

/**
 * What the marker beside a rule means: it comes from the employee's home department, so this department's
 * Wage Settings can't change it. Drawn only when a line carries the marker.
 */
export const HomeDepartmentNote: FC<Props> = ({ composition }) => {
	const { t } = useTranslation();
	const { chosenDepartment } = useHospitalData();
	if (!hasOtherDepartmentRule(composition, chosenDepartment.department_id)) return null;
	return (
		<Typography data-testid="wage-breakdown-home-department-note" sx={{ px: 2, pb: 1.25, fontSize: FONT_SIZE.CAPTION, color: "text.secondary" }}>
			{OTHER_DEPARTMENT_MARKER} {t("wageBreakdown.homeDepartmentNote")}
		</Typography>
	);
};
